import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors } from '../../constants';

export const SpinnerIcon = styled(FontAwesomeIcon)`
  color: ${colors.red};
  font-size: ${(props) => props.size}px;
`;
